import { Box, Container, Flex, useColorMode } from "@chakra-ui/react";

import PricingDetails from "./PricingDetails";
import PricingFAQ from "./PricingFAQ";
import PricingFeatures from "./PricingFeatures";

const PricingCard = () => {
  const { colorMode } = useColorMode();

  return (
    <Box py={{ base: 8, md: 16 }} position="relative">
      {/* Background pattern */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        opacity={0.5}
        bgImage={
          colorMode === "light"
            ? "radial-gradient(circle at 1px 1px, rgba(0,0,0,0.03) 1px, transparent 0)"
            : "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.03) 1px, transparent 0)"
        }
        bgSize="40px 40px"
      />

      <Container maxW="5xl" position="relative">
        {/* Main Pricing Card */}
        <Box
          bg={colorMode === "light" ? "white" : "neutral.800"}
          borderRadius="3xl"
          overflow="hidden"
          boxShadow={
            colorMode === "light"
              ? "0 25px 50px rgba(0, 0, 0, 0.1)"
              : "0 25px 50px rgba(0, 0, 0, 0.4)"
          }
          border="1px solid"
          borderColor={colorMode === "light" ? "neutral.100" : "neutral.800"}
          position="relative"
        >
          {/* Gradient accent line */}
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            h="4px"
            bgGradient="linear(to-r, brand.500, brand.700)"
          />

          <Flex direction={{ base: "column", lg: "row" }}>
            <PricingFeatures />
            <PricingDetails />
          </Flex>
        </Box>

        <PricingFAQ />
      </Container>
    </Box>
  );
};

export default PricingCard;
